import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import MoneyInput           from './MoneyInput';
import ButtonChoiceInput    from './ButtonChoiceInput';
import TextInput            from './TextInput';

class ChildQuestion extends Component {
    /**
     * Renders out the desired field type based on props passed to this component.
     *
     * @returns {XML}
     */
    renderField() {
        switch (this.props.type) {
            case 'money':
                return <MoneyInput {...this.props} />;
            case 'button-choice':
                return <ButtonChoiceInput {...this.props} />;
            default:
                // Default to text field if type has not been defined
                return <TextInput {...this.props} />;
        }
    }

    render() {
        return (
            <div className="stacked-input">
                <label htmlFor={this.props.fieldName}>{this.props.question}</label>
                {this.renderField()}
            </div>
        );
    }
}

ChildQuestion.propTypes = {
    fieldName:              PropTypes.string.isRequired,
    storageKey:             PropTypes.string,
    question:               PropTypes.string.isRequired,
    type:                   PropTypes.string.isRequired,
    options:                PropTypes.array,
    children:               PropTypes.array,
    hasAlternateBackground: PropTypes.bool,
    hasBorder:              PropTypes.bool,
    hasPadding:             PropTypes.bool,
    allowFileUploads:       PropTypes.bool,
    allowCameraUploads:     PropTypes.bool,
    callbackFunction:       PropTypes.func,
    maxLength:              PropTypes.number,
    dataValidation:         PropTypes.string,
    defaultText:            PropTypes.string,
    defaultValue:           PropTypes.string,
    fieldTitle:             PropTypes.string,
    placeholder:            PropTypes.string,
    titleLevel:             PropTypes.number,
    helpText:               PropTypes.string,
    inputExtra:             PropTypes.string,
    inputMask:              PropTypes.string,
    labelExtra:             PropTypes.string,
    layoutClass:            PropTypes.string,
    subType:                PropTypes.string,
    modalOptions:           PropTypes.shape({
        title:                  PropTypes.string.isRequired,
        content:                PropTypes.string.isRequired,
        description:            PropTypes.string.isRequired,
        trigger:                PropTypes.string.isRequired,
        hasFooter:              PropTypes.bool,
        isAlert:                PropTypes.bool,
    }),
    addressOptions:         PropTypes.shape({
        pafLookup:              PropTypes.bool.isRequired,
        canHaveManualEntry:     PropTypes.bool,
        canBeForeign:           PropTypes.bool,
    }),
};

export default ChildQuestion;


// WEBPACK FOOTER //
// ./src/components/Fields/ChildQuestion.js